import lodash from "lodash";
import moment from "moment";
import { createField } from "./inform-product-tab.section";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const fetchCriteria = props.fetchCriteria;
    const isLoading = props.isLoading;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    data.fields = createField({ props, data, refs, key, isLoading });
    if (model?.id) {
        data.product = {
            fetchCriteria: fetchCriteria
                ? fetchCriteria
                : {
                      select: [
                          "**",
                          "refHazObject.refSpecies.*",
                          "refCoordinateCustoms.refUnit.*",
                          "refCoordinateCustoms.refDetailSubStanceType.*",
                          "refHaz.refManufactureCountry.*",
                          "refHazLicense.refQuantityUnit.*"
                      ],
                      page: 0,
                      size: 1000000,
                      where: [{ name: "refInform.id", type: "UUID", operator: "=", value: model.id }],
                      sort: [{ name: "createDate", type: "ASC" }],
                      children: [
                          {
                              name: "addresses",
                              select: ["**"],
                              page: 0,
                              size: 1,
                              where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                          },
                          {
                              name: "refHazObject.hazObjectCoordinates",
                              select: ["*", "refCoordinateCustoms.*", "refCoordinateCustoms.refUnit.*", "refCoordinateCustoms.refDetailSubStanceType.*"],
                              page: 0,
                              size: 1000000
                          },
                          {
                              name: "refHaz.mainSubStances",
                              select: ["*", "refSubStance.*", "refUnit.*"],
                              page: 0,
                              size: 1000000,
                              sort: [{ name: "createDate", type: "ASC" }]
                          },
                          {
                              name: "refHazLicense.hazLicenseStorageLocations",
                              select: ["*", "refStorageLocation.*"],
                              page: 0,
                              size: 1000000,
                              where: [
                                  { name: "refStorageLocation.isActive", type: "Boolean", operator: "=", value: true },
                                  { name: "refStorageLocation.isTemp", type: "Boolean", operator: "=", value: false },
                                  { name: "refStorageLocation.refStatus.key", type: "String", operator: "=", value: "complete" },
                                  { name: "refStorageLocation.effectiveDate", type: "Date", operator: "<=", value: moment().format("YYYY-MM-DD") },
                                  { name: "refStorageLocation.expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
                                  { name: "refStorageLocation.isLocation", type: "Boolean", operator: "=", value: true }
                              ],
                              sort: [{ name: "createDate", type: "ASC" }],
                              children: [
                                  {
                                      name: "refStorageLocation.subs",
                                      select: ["*"],
                                      page: 0,
                                      size: 1000000,
                                      sort: [{ name: "createDate", type: "ASC" }],
                                      children: [
                                          {
                                              name: "items",
                                              select: ["*"],
                                              page: 0,
                                              size: 1000000,
                                              where: [
                                                  { name: "refHaz.id", type: "ScriptJs", operator: "=", value: `dataRoot.refHaz.id` },
                                                  {
                                                      name: "refHazLicense.refOperation.key",
                                                      type: "String",
                                                      operator: "=",
                                                      value: "2"
                                                  }
                                              ]
                                          }
                                      ]
                                  }
                              ]
                          }
                      ]
                  }
        };
    }
};
